import { isWithinLastDays } from '@/utils/date';

/** A consultation is reviewable only within this many days of its starts_at. */
export const REVIEW_WINDOW_DAYS = 30;

/** True when a consultation is still eligible for a review CTA/nudge. */
export const isReviewable = (startsAt: string | null | undefined): boolean =>
  isWithinLastDays(startsAt, REVIEW_WINDOW_DAYS);
